import { useApolloClient } from '@apollo/react-hooks';
import gql from 'not-graphql-tag';
import {
  IsPersonalIdValidParams,
  PersonIdentificationCheckInput,
  PersonIdentificationCheckInputResponse,
} from '../__generated__/pge-types';

const isPersonalIdentificationValid = gql`
  query isPersonalIdentificationValid($params: IsPersonalIdValidParams) {
    isPersonalIdentificationValid(params: $params)
  }
`;

const isLastFourDigitsPersonIdentificationValid = gql`
  query PersonIdentificationCheck($payload: PersonIdentificationCheckInput!) {
    personIdentificationCheck(payload: $payload) {
      isValid
    }
  }
`;

export default () => {
  const client = useApolloClient();

  async function validateId(params: IsPersonalIdValidParams): Promise<boolean> {
    const { data } = await client.query({
      query: isPersonalIdentificationValid,
      variables: { params },
      fetchPolicy: 'network-only',
    });

    const isValid = data?.isPersonalIdentificationValid;
    return isValid;
  }

  async function validateLastFourDigitPersonId(
    payload: PersonIdentificationCheckInput,
  ): Promise<boolean> {
    const { data } = await client.query<{
      personIdentificationCheck: PersonIdentificationCheckInputResponse;
    }>({
      query: isLastFourDigitsPersonIdentificationValid,
      variables: { payload },
      fetchPolicy: 'network-only',
    });

    return !!data?.personIdentificationCheck.isValid;
  }

  return {
    validateId,
    validateLastFourDigitPersonId,
  };
};
